'use strict'

import React from 'react'

require('styles//MainVisual.less')
require('gsap')

var classNames = require('classnames')
var browser = require('./browser')

let logoImage = require('../images/logo.png')
let headerImage = require('../images/header.png')
var headerImageStyle = {
  backgroundImage:'url(' + headerImage + ')'
}
let headerTop = require('../images/header_top.svg')
let headerLt = require('../images/header_lt.png')
let headerBottom = require('../images/header_bottom.svg')

class MainVisualComponent extends React.Component {
  constructor(props)
  {
    super(props);
    this.state = {
      isAppear:true
    }
    browser.init()
  }
  componentDidMount()
  {
    var ismobile = false
    if (browser.ua.isMobile || browser.ua.isIOS || browser.ua.isAndroid)
    {
      ismobile = true
    }
    if (!ismobile)
    {
      window.addEventListener('scroll', this.scroll.bind(this))
      TweenMax.to('.logo', 2.0, {css:{opacity:1.0}, delay:0.8, ease:Sine.easeInOut, onComplete:function(){
        TweenMax.to('.opening', 1.2, {css:{opacity:0.0}, delay:1.5, ease:Sine.easeInOut, onComplete:function(){
          TweenMax.to(['.lt', '.top', '.bottom'], 1.0, {css:{opacity:1.0}, delay:0.1, ease:Sine.easeInOut})
        }.bind(this)})
      }.bind(this)})
    }
  }
  componentWillUnmount()
  {
    window.removeEventListener('scroll', this.scroll.bind(this))
  }
  scroll(e)
  {
    var sh;
    if (e.srcElement)
    {
      sh = e.srcElement.body.scrollTop
    }
    else
    {
      sh = e.target.body.scrollTop
    }
    if (sh > window.innerHeight)
    {
      if (this.state.isAppear)
      {
        this.setState({
          isAppear:false
        })
      }
    }
    else
    {
      if (!this.state.isAppear)
      {
        this.setState({
          isAppear:true
        })
      }
    }
  }
  render()
  {
    var cl = classNames({
      'appear':this.state.isAppear
    })
    return (
      <header id='mainvisual' className={cl} style={headerImageStyle}>
        <div className='opening'>
          <img className='logo' src={logoImage} alt='ハルをさがして' />
        </div>
        <img className='lt' src={headerLt} alt='' />
        <img className='top' src={headerTop} alt='ハルをさがして LOOKING FOR HARU' />
        <img className='bottom' src={headerBottom} alt='8.6（土）より夏休みロードショー　下北沢トリウッド' />
      </header>
    )
  }
}

MainVisualComponent.displayName = 'MainVisualComponent'

// Uncomment properties you need
// MainVisualComponent.propTypes = {}
// MainVisualComponent.defaultProps = {}

export default MainVisualComponent



/** WEBPACK FOOTER **
 ** ./src/components/MainVisualComponent.js
 **/